import { TranslateCompiler } from "@ngx-translate/core";

/*
  based on https://github.com/ngx-translate/core/issues/469 discussion
 */

export class JSONPointerCompiler extends TranslateCompiler {
  private static refRegExp = /@:(\S+)/;

  public compile(value: string, lang: string): string {
    return value;
  }

  public compileTranslations(translations: any, lang: string) {
    for (const key in translations) {
      if (translations.hasOwnProperty(key)) {
        translations[key] = this.resolveReferences(translations[key], translations);
      }
    }
    return translations;
  }

  private resolveReferences(value: string, translations: any) {
    return value.replace(JSONPointerCompiler.refRegExp, (matches, key) =>
      this.resolveReferences(translations[key], translations),
    );
  }
}
